module.exports = __webpack_public_path__ + "img/printer.4551497d.svg";